import React from 'react'
import { Card, Form, Button, Container, ListGroup, Image } from 'react-bootstrap';
import courier from '../../assets/img/courier.jpg'
import { RiArrowDownDoubleFill } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import useStartSingleClaim from '../../hook/useStartSingleClaim';






const MissingWarning = () => {

    const navigate = useNavigate()

    const {startClaim} = useStartSingleClaim()
  

    const handleClick = () => {
        startClaim("4")
        navigate('/missing-summary')
    }


    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Card className="custom-card text-center">
          <Card.Body>
            <Image src={courier} alt="Courier Image" className="image-warning-courier" />
  
            <Card.Text className='first-text'>
              Paketiniz apartman/güvenlik görevlisi veya teslimat adresindeki kişilere teslim edilmiş olabilir.
            </Card.Text>
            <RiArrowDownDoubleFill size={24} />
  
            <Card.Text>
              Kontrollerinizi yaptıktan sonra, paketiniz belirtilen gün sonunda size teslim edilmediyse buradan talep
              oluşturarak müşteri hizmetlerine ulaşabilirsiniz.
            </Card.Text>
  
            <Button variant="primary" className="custom-button-ok">
              Anladım
            </Button>
  
            <Button variant="primary" className="custom-button" style={{marginBottom:'20px'}} onClick={handleClick}>
              Şimdi talep oluştur
            </Button>
          </Card.Body>
        </Card>
      </Container>
    );
  };
  
  export default MissingWarning;